import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Input, Label,Tooltip
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import MinioClient from '../../../../services/minioClient'
import moment from "moment"

class IndexView extends Component {

    timer
    detailBloc = new DetailBloc();
    minioClient = new MinioClient()
    constructor(props) {
        // const queryParams = new URLSearchParams(this.props.location.search);
        super(props)
        this.state = {
            tooltip: false,
            tooltipStyle: {
                marginBottom: 2,
                backgroundColor: "#000",
                color: "#FFF",
                border: "1px solid #000",
            },
            dataForm: {},
            positionOption: [],
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
            detail:[],
            month:'',
            year:2024,
            upload_skp_detail_nama: '',
            upload_skp_detail_skp_hasil_kerja: '',
            upload_skp_detail_skp_perilaku_kerja: '',
            upload_skp_detail_skp_hasil_akhir: '',
            special_allowance_summary_skp_file_path: '',
            dokumen_skp:[],
            docfiles:[],
        }
    }
    // previewDocument(urlPath) {
    //     // alert(urlPath)
    //     this.setState({
    //         loading: true
    //     })
    //     this.minioClient.get(urlPath).then((url) => {
    //         this.setState({
    //             loading: false
    //         })
    //         alert(url)
    //         window.open(url, "_blank")
    //     })
    // }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadDetail = async () => {
        
        const queryParams = new URLSearchParams(window.location.search);
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })      
    
    }

    getMonth = (angkaBulan) => {
        const months = [
            "Januari",
            "Februari",
            "Maret",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Agustus",
            "September",
            "Oktober",
            "November",
            "Desember",
        ];
            return months[angkaBulan-1];
    }

    componentDidMount() {
        this.loadDetail()
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const response = result.data.response;
                    // debugger
                    this.setState(
                        {
                            detail: response.result,
                            dokumen_skp : response.result.document
                        })
                    break
                default:
                    break
            }
        }) 
    }

    componentWillUnmount() {
        this.detailBloc.detailChannel?.unsubscribe()
    }

   customFormRow = (labelText, detailData, isLoading) => {
        return (
          <Row className="mb-3">
            <label htmlFor="name" className="col-md-3 col-form-label">
              {labelText}
            </label>
            <Col md="3">
              {isLoading ? (
                <Shimmer>
                  <div
                    style={{
                      width: '480px',
                      height: '16px',
                      alignSelf: 'center',
                      borderRadius: '8px',
                      marginTop: 'calc(0.47rem + 1px)',
                      marginBottom: 'calc(0.47rem + 1px)',
                      fontSize: 'inherit',
                      lineHeight: '1.5',
                    }}
                  />
                </Shimmer>
              ) : (
                <Label className="col-form-label">{detailData || '-'}</Label>
              )}
            </Col>
          </Row>
        );
      };

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/kepegawaian/skp.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail SKP</CardTitle>
                            <hr />
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Bulan
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.detail.upload_skp_detail_month !== "" ? this.getMonth(this.state.detail.upload_skp_detail_month) : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Tahun
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.detail.upload_skp_detail_year !== "" ? this.state.detail.upload_skp_detail_year : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Pegawai
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.detail.upload_skp_detail_nama !== "" ? this.state.detail.upload_skp_detail_nama : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Hasil Kerja
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.detail.upload_skp_detail_skp_hasil_kerja !== "" ? this.state.detail.upload_skp_detail_skp_hasil_kerja : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Perilaku Kerja
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.detail.upload_skp_detail_skp_perilaku_kerja !== "" ? this.state.detail.upload_skp_detail_skp_perilaku_kerja : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Hasil Akhir
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.detail.upload_skp_detail_skp_hasil_akhir !== "" ? this.state.detail.upload_skp_detail_skp_hasil_akhir : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                    File SKP
                                </label>
                                <Col md="8">
                                {
                                this.state.dokumen_skp ? (
                                    this.state.dokumen_skp.documents_path ? (
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-sm btn-primary"
                                        href={this.state.dokumen_skp.documents_path}
                                    >
                                        <i className="uil-file-download"></i>{" "}
                                        Download File {" - " + this.state.dokumen_skp.documents_name}
                                    </a>
                                    ) : (
                                    <span>Tidak ada file</span>
                                    )
                                ) : (
                                    <Shimmer>
                                    <div style={{ width: 300, height: 15 }} />
                                    </Shimmer>
                                )
                                }


                                {Array.isArray(this.state.dokumen_skp) &&
                                    this.state.dokumen_skp.map((data) => (
                                        <Row className="mb-3" key={data.documents_uuid}>
                                        <Col md="12">
                                            {data.documents_path ? (
                                            data.documents_path !== "" ? (
                                                <a
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-sm btn-primary"
                                                href={data.documents_path}
                                                >
                                                <i className="uil-file-download"></i>{" "}
                                                Download File {" - " + data.documents_name}
                                                </a>
                                            ) : (
                                                "Tidak ada dokumen"
                                            )
                                            ) : (
                                            "Tidak ada dokumen"
                                            )}
                                        </Col>
                                        </Row>
                                    ))}

                                </Col>
                            </Row>
                            
                        </CardBody>
                    </Card>

                </Container>
               
            </Fragment>
        )
    }

}

export default IndexView